import { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';
import LanguageToggler from '../utilPages/LanguageToggler';
import LoginButton from '../utilPages/LoginButton';

const navKeys = [
  { key: 'navPractice', refKey: 'practice' },
  { key: 'navFormats', refKey: 'formats' },
  { key: 'navSchedule', refKey: 'schedule' },
  { key: 'navPrices', refKey: 'prices' },
  { key: 'navAbout', refKey: 'about' },
  { key: 'navContacts', refKey: 'contacts' },
];

const visibleNavKeys = (refs) =>
  navKeys.filter(({ refKey }) => refs?.[refKey] != null);

export default function Navbar({ scrollToRef, refs, onSignUp }) {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (refKey) => {
    const ref = refs?.[refKey];
    if (ref?.current) ref.current.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 px-6 py-5 md:px-12 border-b border-clay/10"
      style={{ backgroundColor: 'rgba(250,248,244,0.9)', backdropFilter: 'blur(12px)' }}
    >
      <div className="flex items-center justify-between max-w-[1600px] mx-auto">
        <a href="/landing" className="font-serif text-[17px] font-medium text-ink no-underline">
          {t.siteName}
        </a>

        <div className="hidden md:flex items-center gap-8">
          {visibleNavKeys(refs).map(({ key, refKey }) => (
            <button
              key={refKey}
              type="button"
              onClick={() => handleNavClick(refKey)}
              className="text-xs font-sans uppercase tracking-widest text-ink-mid hover:text-clay transition-colors"
            >
              {t[key]}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <span className="hidden md:inline">
            <LanguageToggler />
          </span>
          <span className="hidden md:inline">
            <LoginButton onLanding />
          </span>
          <button
            type="button"
            onClick={() => { onSignUp?.(); setIsMenuOpen(false); }}
            className="text-xs font-sans font-medium text-clay border-b border-clay pb-0.5 hover:opacity-80 bg-transparent border-t-0 border-x-0 cursor-pointer"
          >
            {t.signUp}
          </button>
          <button
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-ink text-xl p-1"
            aria-label={t.menuAria}
          >
            ☰
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 py-4 px-6 border-b border-clay/10 bg-warm-white/95 backdrop-blur-md flex flex-col gap-3">
          {visibleNavKeys(refs).map(({ key, refKey }) => (
            <button
              key={refKey}
              type="button"
              onClick={() => handleNavClick(refKey)}
              className="text-left text-sm font-sans uppercase tracking-wider text-ink-mid hover:text-clay"
            >
              {t[key]}
            </button>
          ))}
          <div className="mt-auto pt-4 border-t border-clay/10 flex flex-col gap-3 text-sm">
            <LoginButton onLanding />
            <div className="md:hidden">
              <LanguageToggler />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
